import React from "react";
import "./ActionTableAICard.scss";
import aiChatlogo from "../../../../../../assets/Images/aiChatlogo.png";
import { SuperChatAIOrderTable } from "../../SuperChatAIOrderTable/SuperChatAIOrderTable";

export const ActionTableAICard = ({
  message,
  title,
  TableComponent,
  onAddUserMessage,
}) => {
  const d = new Date(message.timestamp || Date.now());
  const day = d.toLocaleDateString(undefined, {
    weekday: "long",
  });
  const time = d.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
  });

  const actionNeededCount = message.actionNeededCount || 0;

  return (
    <div className="action-table-ai-card ai-left">
      <div className="action-table-ai-header">
        <img src={aiChatlogo} alt="Axon AI" className="action-table-ai-logo" />
        <div className="action-table-ai-title">
          <span>{title || "Axon AI"}</span>
          <div className="action-table-time">{`${day} ${time}`}</div>
        </div>
      </div>
      <div className="action-table-ai-bubble-inner">
        {message.text}
        {message.orders && message.orders.length > 0 ? (
          <>
            {TableComponent ? (
              <TableComponent
                orders={message.orders}
                message={message}
                onAddUserMessage={onAddUserMessage}
                actionNeededCount={actionNeededCount}
              />
            ) : (
              <SuperChatAIOrderTable
                orders={message.orders}
                message={message}
                onAddUserMessage={onAddUserMessage}
                actionNeededCount={actionNeededCount}
              />
            )}
          </>
        ) : (
          <>
            <p className="no-orders-message">No open orders available.</p>
            {actionNeededCount > 0 && (
              <p className="action-needed-message">
                However there {actionNeededCount === 1 ? "is" : "are"}{" "}
                {actionNeededCount} order{actionNeededCount === 1 ? "" : "s"}{" "}
                where the User's action is needed.
              </p>
            )}
          </>
        )}
      </div>
    </div>
  );
};
